import prepareFormForSubmit from './prepareFormForSubmit';
import { equals } from 'ramda';
import { FieldJson } from 'edocatbase/Form';

// TODO: need debug, not sure if it works for all cases
const didFormChange = (fields: { [key: string]: FieldJson }, initialFields: { [key: string]: FieldJson }) => {
  const result = prepareFormForSubmit(fields);
  const initialFieldsResult = prepareFormForSubmit(initialFields);

  return !equals(result, initialFieldsResult);
};

export default didFormChange;
